// src/components/AppleCard.tsx
import React from "react";
import clsx from "clsx";
import { A } from "../styles/appleClasses";

type AppleCardProps = React.HTMLAttributes<HTMLDivElement> & {
  padding?: string; // e.g. "p-6" | "p-8"
};

export function AppleCard({ className, padding = "p-6", ...props }: AppleCardProps) {
  return <div {...props} className={clsx(A.card, padding, className)} />;
}
